import React, {MouseEventHandler, useState} from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import cs from 'classnames';

type TProductIdProps = Pick<IProductSnippet, 'id'> & {className?: string};

export const ProductId = (props: TProductIdProps) => {
    const [isShownCopied, setIsShownCopied] = useState(false);
    const [isFade, setIsFade] = useState(false);
    const [isCooldown, setIsCooldown] = useState(false);
    const {id, className} = props;

    const handleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
        e.preventDefault();

        if (isCooldown) {
            return;
        }

        setIsCooldown(true);

        navigator.clipboard.writeText((e.target as HTMLElement).innerText);
        setIsShownCopied(true);
        setIsFade(true);

        setTimeout(() => {
            setIsFade(false);
        }, 1500);

        setTimeout(() => {
            setIsShownCopied(false);
            setIsCooldown(false);
        }, 2000);
    };

    return (
        <div className={cs(style.main, className)}>
            <button type={'button'} className={style.idButton} onClick={handleClick}>
                <Typography className={style.productId} variant={'label-12-r'}>
                    {id}
                </Typography>
            </button>
            {isShownCopied && (
                <div className={cs(style.copied, {[style.copied_shown]: isFade})}>
                    <Typography variant={'label-12-m'}>Скопировано</Typography>
                </div>
            )}
        </div>
    );
};
